import { OddsAcceptanceMode } from '@bpos';

export interface ISettingsState {
    // We have odds acceptance on user level but on bet station the value is taken from the local storage and not saved to the user on change, so we need to copy it.
    oddsAcceptance: OddsAcceptanceMode;
    notifications: {
        emailNotify: boolean;
        appNotify: boolean;
    };
}

export const defaultSettingsState: ISettingsState = {
    oddsAcceptance: OddsAcceptanceMode.No,
    notifications: {
        emailNotify: false,
        appNotify: false,
    },
};
